var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"save-status"},[(_vm.isSuccess || _vm.isSaving)?_c('autosave-status',{attrs:{"saving":_vm.isSaving}}):(_vm.isFailed)?_c('ds-status',{attrs:{"type":"error","emphasis":"medium","data-qa":"save-failed"}},[_vm._v(" Save failed ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }